// src/layouts/CustomerMasterLayout.jsx
import React, { useState, useEffect, useContext } from "react";
import CustomerSidebar from "../components/customer/sidebar/CustomerSidebar";
import CustomerTopbar from "../components/customer/topbar/CustomerTopbar";
import "../assets/css/layouts/customerMasterLayout/CustomerMasterLayout.css";
import MyContext from "../context/MyContext";

const CustomerMasterLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const { setAuthToken, setLoggedInCustomer } = useContext(MyContext);
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile) setIsMobileOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setAuthToken(authToken);
    let customer = localStorage.getItem("loggedInCustomer");
    console.log(customer);
    if (customer != undefined) {
      console.log(customer);
      setLoggedInCustomer(JSON.parse(localStorage.getItem("loggedInCustomer")));
    }
  }, []);

  return (
    <div className="sel-layout">
      <CustomerSidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
        isMobile={isMobile}
      />

      <div
        className={[
          "sel-main",
          !isMobile && isCollapsed ? "sel-main--collapsed" : "",
          isMobile ? "sel-main--mobile" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <CustomerTopbar
          sidebarOpen={isMobileOpen}
          setSidebarOpen={setIsMobileOpen}
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          isMobile={isMobile}
        />

        <div className="sel-content">{children}</div>
      </div>
    </div>
  );
};

export default CustomerMasterLayout;
